<div>

  <!-- Page Header -->
  <div class="page-header">
    <div class="page-title-wrap">
      <h2 class="page-title">Container Margins</h2>
    </div>
    @if (addPermission) {
      <button mat-flat-button color="primary" class="add-btn" (click)="onAdd()">
        + Add Container Margin
      </button>
    }
  </div>

  <!-- List Table -->
  <mat-card class="table-card">
    <mat-card-content>
      <div class="table-scroll-container">
        <table mat-table [dataSource]="dataSource" class="list-table">

          <ng-container matColumnDef="refNo">
            <th mat-header-cell *matHeaderCellDef>REF NO.
              <div class="sorting_header">
                <input type="search" placeholder="Search Ref No..." autocomplete="off"
                  [formControl]="refNoFilter">
                </div>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="ref-no">{{row.refNo}}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="wefDate">
              <th mat-header-cell *matHeaderCellDef>WEF DATE
                <div class="sorting_header">
                  <div class="date-filter-wrap">
                    <input [matDatepicker]="wefFilterPicker" [formControl]="wefDateFilter"
                      placeholder="DD/MM/YYYY" autocomplete="off" readonly>
                      @if (wefDateFilter.value) {
                        <button class="date-clear-btn" type="button"
                          (click)="wefDateFilter.reset()">
                          <mat-icon>close</mat-icon>
                        </button>
                      }
                      <mat-datepicker-toggle [for]="wefFilterPicker"></mat-datepicker-toggle>
                      <mat-datepicker #wefFilterPicker></mat-datepicker>
                    </div>
                  </div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <span class="date-val">{{row.wefDate | date: 'dd/MM/yyyy'}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="businessSegment">
                <th mat-header-cell *matHeaderCellDef>BUSINESS SEGMENT
                  <div class="sorting_header">
                    <mat-select [formControl]="businessSegmentFilter" placeholder="All">
                      <mat-option [value]="null">All</mat-option>
                      @for (s of segments; track s) {
                        <mat-option [value]="s.id">
                          {{s.businessSegmentName}}
                        </mat-option>
                      }
                    </mat-select>
                  </div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <span class="segment-badge"
                    [ngClass]="{'segment-badge--fcl': row.businessSegmentName?.includes('FCL')}">
                    {{row.businessSegmentName}}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>ACTION</th>
                <td mat-cell *matCellDef="let row">
                  @if (viewPermission) {
                    <button mat-stroked-button class="edit-btn" (click)="onEdit(row)">
                      <mat-icon>edit</mat-icon> Edit
                    </button>
                  }
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>

          <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="totalRecords"
          showFirstLastButtons></mat-paginator>
        </mat-card-content>
      </mat-card>

    </div>